// ==========================================================================
// Shopmyzo - Interactive Scripting
// ==========================================================================

document.addEventListener('DOMContentLoaded', () => {
    // Initialize before/after progress bar animation on scroll
    initScrollAnimations();
    
    // Auto-scroll promo announcement bar messages
    initPromoScroll();
});

// 1. Hero Image Gallery Switcher
function changeImage(imageSrc, thumbnailElement) {
    const mainImg = document.getElementById('gallery-main-img');
    if (!mainImg) return;
    
    // Smooth transition fade out
    mainImg.style.opacity = '0.3';
    
    setTimeout(() => {
        mainImg.src = imageSrc;
        mainImg.style.opacity = '1';
    }, 150);

    // Update active class on thumbnails
    const thumbnails = document.querySelectorAll('.thumbnail');
    thumbnails.forEach(thumb => thumb.classList.remove('active'));
    
    if (thumbnailElement) {
        thumbnailElement.classList.add('active');
    }
}

// 2. Interactive Bundle Selector
function selectBundle(bundleId) {
    const radioBtn = document.getElementById(bundleId);
    if (!radioBtn) return;
    
    // Check the radio button
    radioBtn.checked = true;
    
    // Update visual active card styles
    const bundleCards = document.querySelectorAll('.bundle-card');
    bundleCards.forEach(card => {
        card.classList.remove('active');
        // Find if this card contains the radio button we checked
        if (card.querySelector(`input#${bundleId}`)) {
            card.classList.add('active');
        }
    });
    
    // Dynamic price updates on Checkout Button if needed
    const ctaBtn = document.getElementById('btn-add-to-cart');
    if (ctaBtn) {
        let price = '$29.99';
        let savingsText = '';
        
        if (bundleId === 'bundle-2') {
            price = '$49.99';
            savingsText = ' (SAVE 15%)';
        } else if (bundleId === 'bundle-3') {
            price = '$64.99';
            savingsText = ' (SAVE 28%)';
        }
        
        ctaBtn.innerHTML = `<span>ADD TO CART - ${price}${savingsText}</span>
        <svg viewBox="0 0 24 24" class="arrow-icon"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>`;
    }
}

// Keep visual and accessibility state in sync for both accordion patterns.
function setAccordionState(item, open) {
    const button = item.querySelector('.accordion-header, .faq-header');
    const panel = item.querySelector('.accordion-content, .faq-content');
    item.classList.toggle('active', open);
    if (button) button.setAttribute('aria-expanded', String(open));
    if (panel) panel.hidden = !open;
}
function toggleAccordion(button) {
    const item = button.parentElement;
    const open = !item.classList.contains('active');
    item.parentElement.querySelectorAll('.accordion-item').forEach(el => setAccordionState(el, false));
    setAccordionState(item, open);
}
function toggleFaq(button) { setAccordionState(button.parentElement, !button.parentElement.classList.contains('active')); }
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.accordion-item, .faq-item').forEach((item, i) => {
        const button = item.querySelector('.accordion-header, .faq-header');
        const panel = item.querySelector('.accordion-content, .faq-content');
        if (!button || !panel) return;
        button.id ||= 'accordion-button-' + i;
        panel.id ||= 'accordion-panel-' + i;
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('aria-labelledby', button.id);
        setAccordionState(item, item.classList.contains('active'));
    });
});

// 5. Interactive Cleaning Mechanism Simulator
let isCleaned = false;

function simulateCleaning() {
    const cleaningPlate = document.getElementById('cleaning-plate');
    const hairStrands = document.getElementById('hair-strands');
    const btnClean = document.getElementById('btn-push-clean');
    const btnReset = document.getElementById('btn-reset-hair');
    
    if (!cleaningPlate || !hairStrands || !btnClean) return;
    
    if (!isCleaned) {
        // Run cleaning animation
        cleaningPlate.classList.add('cleaned');
        hairStrands.classList.add('pushed');
        
        btnClean.textContent = "Grime Lifted!";
        btnClean.style.backgroundColor = "var(--color-success)";
        btnClean.style.color = "#ffffff";
        btnClean.style.borderColor = "var(--color-success)";
        btnClean.classList.remove('pulse-element');
        
        // Show reset option
        if (btnReset) {
            btnReset.style.display = 'block';
        }
        isCleaned = true;
    }
}

function resetSimulation() {
    const cleaningPlate = document.getElementById('cleaning-plate');
    const hairStrands = document.getElementById('hair-strands');
    const btnClean = document.getElementById('btn-push-clean');
    const btnReset = document.getElementById('btn-reset-hair');
    
    if (!cleaningPlate || !hairStrands || !btnClean || !btnReset) return;
    
    // Reset classes
    cleaningPlate.classList.remove('cleaned');
    hairStrands.classList.remove('pushed');
    
    // Reset controls
    btnClean.textContent = "Power On & Scrub";
    btnClean.style.backgroundColor = "";
    btnClean.style.color = "";
    btnClean.style.borderColor = "";
    btnClean.classList.add('pulse-element');
    
    btnReset.style.display = 'none';
    isCleaned = false;
}

// 6. Technology hotspots interactive overlays
function showTooltip(pinId) {
    const tooltip = document.getElementById(`tooltip-${pinId}`);
    if (tooltip) {
        tooltip.classList.add('active');
    }
}

function hideTooltip(pinId) {
    const tooltip = document.getElementById(`tooltip-${pinId}`);
    if (tooltip) {
        tooltip.classList.remove('active');
    }
}

// Support mobile taps on hotspots
document.querySelectorAll('.hotspot-pin').forEach(pin => {
    pin.addEventListener('click', (e) => {
        e.stopPropagation();
        const pinDot = pin.querySelector('.pin-dot');
        const pinNumber = pinDot.textContent.trim();
        
        const allTooltips = document.querySelectorAll('.hotspot-tooltip');
        const targetTooltip = document.getElementById(`tooltip-${pinNumber}`);
        
        const isCurrentlyActive = targetTooltip.classList.contains('active');
        
        allTooltips.forEach(t => t.classList.remove('active'));
        
        if (!isCurrentlyActive && targetTooltip) {
            targetTooltip.classList.add('active');
        }
    });
});

document.addEventListener('click', () => {
    const allTooltips = document.querySelectorAll('.hotspot-tooltip');
    allTooltips.forEach(t => t.classList.remove('active'));
});

// 7. Customer Reviews Carousel Slider
let currentReviewIndex = 0;

function moveSlider(direction) {
    const wrapper = document.getElementById('reviews-wrapper');
    if (!wrapper) return;
    
    const cards = document.querySelectorAll('.review-card');
    const totalCards = cards.length;
    
    // Determine screen columns
    let visibleCards = 3;
    if (window.innerWidth <= 768) visibleCards = 1;
    else if (window.innerWidth <= 1024) visibleCards = 2;
    
    const maxIndex = totalCards - visibleCards;
    
    currentReviewIndex += direction;
    
    if (currentReviewIndex < 0) {
        currentReviewIndex = 0;
    } else if (currentReviewIndex > maxIndex) {
        currentReviewIndex = maxIndex;
    }
    
    // Calculate scroll offset percent
    let cardWidthPercent = 100 / visibleCards;
    let offset = currentReviewIndex * (cardWidthPercent + (direction * 1)); // adjust gap offsets slightly
    
    // Apply slide
    const cardGap = 30; // matching CSS gap
    const totalOffset = currentReviewIndex * (cards[0].offsetWidth + cardGap);
    wrapper.style.transform = `translateX(-${totalOffset}px)`;
}

// Keep reviews slider positioning accurate on resize
window.addEventListener('resize', () => {
    currentReviewIndex = 0;
    const wrapper = document.getElementById('reviews-wrapper');
    if (wrapper) {
        wrapper.style.transform = 'translateX(0)';
    }
});

// 8. Progress Bars Scroll Animation trigger
function initScrollAnimations() {
    const progressFillElements = document.querySelectorAll('.progress-fill');
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const fillElement = entry.target;
                // Read inline style width and apply to animate
                const targetWidth = fillElement.style.width;
                fillElement.style.width = '0%';
                
                // Trigger reflow to restart animation
                void fillElement.offsetWidth;
                
                fillElement.style.width = targetWidth;
                observer.unobserve(fillElement);
            }
        });
    }, { threshold: 0.2 });
    
    progressFillElements.forEach(el => observer.observe(el));
}

// 9. Announcement bar simple message fade loop
function initPromoScroll() {
    const textWrapper = document.querySelector('.announcement-text');
    if (!textWrapper) return;
    
    // We can add logic to toggle different messages every 5s if desired.
    // Right now, it displays a dual message which fits great on desktop and wraps/scrolls elegantly.
}

// Mobile menu drawer toggle
function toggleMobileMenu() {
    const nav = document.getElementById('mobile-nav');
    const overlay = document.getElementById('mobile-nav-overlay');
    const toggle = document.querySelector('.mobile-menu-toggle');
    if (!nav) return;

    const open = nav.classList.toggle('active');
    if (overlay) overlay.classList.toggle('active', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
}

// 10. Storefront Search Overlay Toggle
function toggleSearch() {
    const overlay = document.getElementById('search-overlay');
    if (!overlay) return;
    
    overlay.classList.toggle('active');
    
    if (overlay.classList.contains('active')) {
        const input = document.getElementById('search-input');
        if (input) input.focus();
    }
}

// Close search / mobile menu on Escape key
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const overlay = document.getElementById('search-overlay');
        if (overlay && overlay.classList.contains('active')) {
            overlay.classList.remove('active');
        }
        const nav = document.getElementById('mobile-nav');
        if (nav && nav.classList.contains('active')) {
            toggleMobileMenu();
        }
    }
});

// 11. E-commerce Currency Dropdown Selector
function toggleCurrencyDropdown() {
    const dropdown = document.getElementById('currency-dropdown');
    if (dropdown) {
        dropdown.classList.toggle('active');
    }
}

function selectCurrency(code, flag, symbol) {
    const btn = document.getElementById('currency-btn');
    const dropdown = document.getElementById('currency-dropdown');
    
    if (!btn || !dropdown) return;
    
    // Update button text
    btn.innerHTML = `<span class="flag-icon">${flag}</span>
                    <span class="currency-code">${code} ${symbol}</span>
                    <span class="chevron">▾</span>`;
                    
    // Hide dropdown
    dropdown.classList.remove('active');
    
    // Dynamically change prices displayed on cards based on a simple converter for demo purposes
    const prices = {
        'AED': { rate: 1.0, symbol: 'Dhs. ' },
        'USD': { rate: 0.27, symbol: '$' },
        'EUR': { rate: 0.25, symbol: '€' },
        'GBP': { rate: 0.21, symbol: '£' }
    };
    
    const config = prices[code];
    if (!config) return;
    
    // AquaSpin Pro Scrubber: Sale 109.99 AED
    // Drain Tablets: Sale 89.99 AED
    // Rust & Grime Remover: Sale 79.99 AED
    // Solar Lanterns: Sale 99.99 AED
    const originalAEDPrices = [109.99, 89.99, 79.99, 99.99];
    const baseOriginals = [219.99, 179.99, 159.99, 179.99];
    
    const cardSaleElements = document.querySelectorAll('.card-sale-price');
    const cardOrigElements = document.querySelectorAll('.card-orig-price');
    
    cardSaleElements.forEach((el, index) => {
        if (originalAEDPrices[index]) {
            const converted = (originalAEDPrices[index] * config.rate).toFixed(2);
            el.textContent = `${config.symbol}${converted} ${code}`;
        }
    });
    
    cardOrigElements.forEach((el, index) => {
        if (baseOriginals[index]) {
            const converted = (baseOriginals[index] * config.rate).toFixed(2);
            el.textContent = `${config.symbol}${converted} ${code}`;
        }
    });
}

// Close currency dropdown when clicking outside
document.addEventListener('click', (e) => {
    const selector = document.querySelector('.currency-selector');
    const dropdown = document.getElementById('currency-dropdown');
    
    if (selector && dropdown && !selector.contains(e.target)) {
        dropdown.classList.remove('active');
    }
});

// 12. Floating Back To Top button
const backToTopBtn = document.getElementById('back-to-top-btn');

window.addEventListener('scroll', () => {
    if (backToTopBtn) {
        if (window.scrollY > 400) {
            backToTopBtn.classList.add('active');
        } else {
            backToTopBtn.classList.remove('active');
        }
    }
});

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// 13. E-commerce Contact Form Submission
function handleContactSubmit(event) {
    event.preventDefault();
    
    const name = document.getElementById('contact-name').value;
    const email = document.getElementById('contact-email').value;
    const comment = document.getElementById('contact-comment').value;
    const form = document.getElementById('store-contact-form');
    
    if (!name || !email || !comment) return;
    
    // Create a beautiful premium modal or toast message instead of standard alert
    const toast = document.createElement('div');
    toast.style.position = 'fixed';
    toast.style.bottom = '30px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%) translateY(100px)';
    toast.style.backgroundColor = 'var(--color-primary)';
    toast.style.color = '#ffffff';
    toast.style.padding = '16px 32px';
    toast.style.borderRadius = '30px';
    toast.style.boxShadow = 'var(--shadow-hard)';
    toast.style.zIndex = '9999';
    toast.style.fontFamily = 'var(--font-heading)';
    toast.style.fontWeight = '600';
    toast.style.transition = 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s';
    toast.style.opacity = '0';
    toast.textContent = `✨ Thank you, ${name}! Your message was sent successfully. We will get back to you shortly. ✨`;
    
    document.body.appendChild(toast);
    
    // Trigger animation slide up
    setTimeout(() => {
        toast.style.transform = 'translateX(-50%) translateY(0)';
        toast.style.opacity = '1';
    }, 100);
    
    // Reset form
    if (form) form.reset();
    
    // Fade out and remove toast
    setTimeout(() => {
        toast.style.transform = 'translateX(-50%) translateY(100px)';
        toast.style.opacity = '0';
        setTimeout(() => {
            document.body.removeChild(toast);
        }, 400);
    }, 5000);
}



